import { type ReactNode } from "react";
import { type Recipe } from "@reciperoll/core";
import { SectionHeader } from "./SectionHeader";
import { ScrollRail } from "./ScrollRail";
import { RecipeGridItem } from "../RecipeGridItem";

// Horizontal scrolling row of recipe cards — shared by Quick Recipes and
// Recently Added (mirrors the two near-identical RN sections). Uses the same
// RecipeGridItem as the library grid so the two never drift, in fixed-width
// slots that scroll horizontally.
export function RecipeRail({
  title,
  icon,
  eyebrow,
  link,
  recipes,
  cookingIds,
}: {
  title: string;
  icon?: ReactNode;
  eyebrow?: string;
  link?: string;
  recipes: Recipe[];
  cookingIds: Set<string>;
}) {
  if (!recipes.length) return null;

  return (
    <div className="mb-8">
      <SectionHeader title={title} icon={icon} eyebrow={eyebrow} link={link} />
      {/* Chevron centred on the card's 4:3 image (~168px tall at w-56). */}
      <ScrollRail className="flex gap-4 pb-2 -mx-1 px-1" chevronTopClass="top-[84px]">
        {recipes.map((recipe) => (
          <div key={recipe.id} className="shrink-0 w-56">
            <RecipeGridItem recipe={recipe} isCooking={cookingIds.has(recipe.id)} />
          </div>
        ))}
      </ScrollRail>
    </div>
  );
}
